import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You're cool that we can buy stuff from other people to sell to you. The same way that a carmaker buys metal from someone else to make the engines they sell in their cars.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      